var pricingCol = $('#arc-product-pricing');
// Main content section - this is where fixed should start
var offset = $('#arc-product-images').offset().top;

var scrollCb = debounce(function(e) {
    var scrollTop = $(window).scrollTop();
    console.log("scrolltop:", scrollTop, "offset:", offset);
    if (scrollTop > offset) {
        pricingCol.addClass("arc-product-pricing-fixed");
    } else {
        pricingCol.removeClass("arc-product-pricing-fixed");
    }
    // console.log("callllled");
}, 10);

// $(window).on("scroll", scrollCb);



function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};